module.exports = __webpack_public_path__ + "img/accessory-banner.4e0122f6.png";